module.exports = __webpack_public_path__ + "img/about_con.933d9c94.png";